import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
// import { isLoggedIn } from '../authorization/authUtils';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function Page404() {
  const navigate = useNavigate();

  // const redirectTo = () => {
  //   if (isLoggedIn()) {
  //     navigate('/dashboard');
  //   } else {
  //     navigate('/');
  //   }
  // };

  const goBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <>
      <Helmet>
        <title>404 Page Not Found | Watchnod</title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            Sorry, page not found!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your
            spelling.
          </Typography>

          <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          {/* <Button size="large" variant="contained" onClick={redirectTo}>
            Go to Home
          </Button> */}
          <Button size="large" variant="contained" onClick={goBack}>
            Go Back
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
